import { useContext } from 'react';
import InputConfig from '../../../../Components/InputConfig';
import { Grid } from '@mui/material';
import Paper from '@mui/material/Paper';
import { FvpConfigContext } from '../../../../Contexts/FvpConfigContext';
import { ACCESS_CONTROL_CONSTANTS } from '../../../../core/constants';
import SwitchInput from '../../../../Components/SwitchInput';
import DropDownSingle from '../../../../Components/DropDownSingle';
import PageHeading from '../../../../Components/PageHeading';
import useCommonStyles from '../../../../commonStyles';

const { SYSTEMS } = ACCESS_CONTROL_CONSTANTS;

/**
 * @name GeneralSettings
 * @description This component is an editor for the networkData root Level configuration.
 *
 *   networkData:{
 *     "globalHbDisabled": false,
 *     "demandSelectionOrder": "SEQUENTIAL",
 *     "hbFloor": 0.5
 *   }
 *
 * @param {{keyData: 'networkData'}} keyData - A keyData used to identify the configuration in the rawConfig object.
 */
const NetworkDataGeneralSettings = ({ keyData }) => {
	const { rawConfig, updateRawConfig } = useContext(FvpConfigContext);
	const commonStyleClasses = useCommonStyles();

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="General Settings"
				headingPath={['Dashboard', 'Fvp', 'Network Data', 'General Settings']}
				description="Manage Network Data configurations here."
			/>
			<Grid
				container
				spacing={1}
				style={{ height: '60%', width: '90%', marginLeft: '4rem', marginTop: '3rem' }}
			>
				<Grid item xs={3} style={{ marginTop: '5rem', marginLeft: '1rem' }}>
					<SwitchInput
						system={SYSTEMS.FVP_PLAYER}
						keyData={keyData + '.globalHbDisabled'}
						label="Global Hb Disabled"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={4}>
					<DropDownSingle
						system={SYSTEMS.FVP_PLAYER}
						keyData={keyData + '.demandSelectionOrder'}
						label="Demand Selection Order "
						list={['RANDOM', 'SEQUENTIAL']}
						formControlStyles={{ width: '70%' }}
						labelStyles={{ width: '100%' }}
						formControlVariant="outlined"
						selectInputStyles={{ margin: '1rem 0' }}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={4}>
					<InputConfig
						system={SYSTEMS.FVP_PLAYER}
						label="Hb Floor"
						keyData={keyData + '.hbFloor'}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
						inputProps={{
							step: 0.1
						}}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default NetworkDataGeneralSettings;
